"use client";

import React from "react";
import { PageLoading as Loading } from "@oreme/ui";

interface SharedPageLoadingProps {
  title: string;
  description: string;
  loading: string;
}

function SharedPageLoading({
  title,
  description,
  loading,
}: Readonly<SharedPageLoadingProps>) {
  return <Loading title={title} lead={description} loading={loading} />;
}

export { SharedPageLoading };
